import { httpAction, getAction, postAction } from '@/api/manage'

/**
 * 获取点线详情
 * @param
 * {
 *      "projectCode": "em_base",
 *      "topologyCode": "em_base_1",
 *      "code": 7,
 *      "name": null
 * } data
 * @returns
 */
export function getPostGreSqlNodeInfoByCode(data) {
  return postAction('/jeecg-gis/topology/node/getNodeByCode', data)
}

export function getPostGreSqlLineInfoByCode(data) {
  return postAction('/jeecg-gis/topology/pipeline/getPipelineByCode', data)
}

export function getPostGreSqlAreaInfoByCode(data) {
  return getAction('/jeecg-gis/area/queryById', {id: data})
}

// 默认导出所有接口方法
export default {
  getPostGreSqlNodeInfoByCode,
  getPostGreSqlLineInfoByCode,
  getPostGreSqlAreaInfoByCode,
}
